// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"122":"e75eb989","296":"46da37a5"}[chunkId] + ".css";
};